import React, { useState } from "react";
import { TranslateContext } from "./translateContext";
export const TranslateProvider = props => {
    const { locale, children } = props;
    const [defaultLocale, setDefaultLocale] = useState(locale);
    return <TranslateContext.Provider value={{ locale: defaultLocale, setLocale: setDefaultLocale }}>
    {children ? children : null}
  </TranslateContext.Provider>;
};
